"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultIconConfig = void 0;
var defaultIconConfig = {
    type: 'material',
    icon: 'done',
    size: 4,
    padding: {
        desktop: 0,
        tablet: 0,
        mobile: 0
    },
    margin: {
        fullHd: 0,
        widescreen: 0,
        desktop: 0,
        tablet: 0,
        mobile: 0
    }
};
exports.defaultIconConfig = defaultIconConfig;
//# sourceMappingURL=Icon.js.map